import styled from 'styled-components';
import { useDesignSchema } from '@Providers/DesignSchemaProvider';
import { useConfig } from '@Src/providers/ConfigProvider';
import { useEffect } from 'react';

const StyledDiv = styled.div`
  padding-top: 25px;
`;

export const Weborder = (): JSX.Element => {
  const designSchema = useDesignSchema();
  const isV2 = designSchema.schemaVersion === 'v2';
  const policyUrls = isV2
    ? designSchema?.config?.policyUrls
    : designSchema.policyUrls;

  const font = isV2 ? designSchema?.globalStyle?.fonts?.primary : null;
  const primaryColor = isV2 ? designSchema?.globalStyle?.colors?.primary : null;

  const { language, appId } = useConfig();
  useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://web-order.flipdish.co/client/productionwlbuild/latest/static/js/main.js?${Date.now()}`;
    document.head.appendChild(script);
  }, []);

  const showFullscreenMobile = isV2 ? 'false' : 'true';

  return (
    <StyledDiv
      id="flipdish-menu"
      data-restaurant={appId}
      data-web-order-source="elixir"
      data-initial-language={language}
      data-force-app="true"
      data-initial-screen="delivery-type"
      data-full-screen-on-mobile={showFullscreenMobile}
      data-terms-link={policyUrls?.terms || '/terms'}
      data-privacy-policy-link={policyUrls?.privacy || '/privacy'}
      data-cookie-policy-link={policyUrls?.cookie || '/cookiepolicy'}
      {...(font ? { 'data-font': font } : {})}
      {...(primaryColor ? { 'data-primary-color': primaryColor } : {})}
    />
  );
};

export default Weborder;
